import aitaskImg from "../../media/undraw_firmware_3fxd.svg";
import "../../css/usermaindash.css";
import lineGraphImg from "../../media/wave-haikei (5).svg";
import filesImg from "../../media/undraw_add-files_d04y.svg";
import { collection, onSnapshot, query, where, getDocs, writeBatch } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import Swal from "sweetalert2";
import usefbStore from "../../store/firebasestore";
import noApplication from "../../media/undraw_updated-resume_287i.svg"
import { useRef, useEffect, useState } from "react";
import wavecard from "../../media/wave-haikei (4).svg"
import { Icon } from "@iconify/react";
import { useMemo } from "react";
import { useSocketStore } from "../../store/socketstore";
import "ldrs/react/Jelly.css";
import { Jelly } from "ldrs/react";
import { useNavigate } from "react-router-dom";
import useStore from "../../store/zustandstore";

function Maindash() {
  const userID = usefbStore((s) => s.userID);
  const taskResp = useRef(null);
  const jobArray = usefbStore((s) => s.jobArray) || [];
  const navigate = useNavigate();
  const isReverified = usefbStore((s)=>s.isReverified)
  const setAllAccountLevels = useStore((state) => state.setAllAccountLevels);
  const authStatus = usefbStore((s) => s.authStatus);
  const hasTasks = usefbStore((s) => s.hasTasks);
  const solaraTokens = usefbStore((s) => s.solaraTokens);
  const totalTaskTaken = usefbStore((s) => s.totalTaskTaken) || 0;
  const taskRespMsg = useSocketStore((s) => s.taskRespMsg);
  const setHasTasks = usefbStore((s) => s.setHasTasks);
  const screeningTest = usefbStore((s) => s.screeningTest);
  const earningsPercentage = usefbStore((s) => s.earningsPercentage);
  const screenCount = usefbStore((s) => s.screenCount)
  const taskRespStatus = useSocketStore((s) => s.taskRespStatus);
  const taskRespCont = useSocketStore((s) => s.taskRespCont);
  const [gettingTask, setGettingTask] = useState(false);
  const taskArray = usefbStore((s) => s.taskArray);
  const accountVerified = usefbStore((s) => s.accountVerified)
  const setTaskArray = usefbStore((s) => s.setTaskArray);
  const isDesktopLeftDashActive = useStore((s) => s.isDesktopLeftDashActive);
  const isDesktopRightDashActive = useStore((s) => s.isDesktopRightDashActive);
  const isDesktopLeftBottomActive = useStore((s) => s.isDesktopLeftBottomActive);
  const accountBalance = usefbStore((s) => s.accountBalance) || 0;
  const jobApplications = usefbStore((s) => s.jobApplications) || [];
  const accountPoints = usefbStore((s) => s.accountPoints) || 0;
  
  const inCooldown = useSocketStore((s) => s.inCooldown);
  const cooldownUntil = useSocketStore((s) => s.cooldownUntil);
  const cooldownMessage = useSocketStore((s) => s.cooldownMessage);
  const fbCooldownUntil = usefbStore((s) => s.taskCooldownUntil);
  const fbInCooldown = usefbStore((s) => s.inCooldown);

  const effectiveInCooldown = inCooldown || fbInCooldown;
  const effectiveCooldownUntil = cooldownUntil || fbCooldownUntil;
  
  const [remainingCooldownSecs, setRemainingCooldownSecs] = useState(0);
  const secApproval = usefbStore((s) => s.secApproval)

  const formatCooldownTime = (seconds) => {
    if (!seconds || seconds <= 0) return null;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) return `${hours}h ${minutes}m`;
    if (minutes > 0) return `${minutes}m ${secs}s`;
    return `${secs}s`;
  };

const appliedJobs = useMemo(() => {
  if (!jobArray.length || !jobApplications.length) return [];


  // create fast lookup map from applications
  const appMap = new Map(
    jobApplications.map(app => [app.jobId, app])
  );

  return jobArray
    .filter(job => appMap.has(job.id))
    .map(job => {
      const application = appMap.get(job.id);

      return {
        ...job,
        applicationId: application.id,
        applicationStatus: application.status,
        appliedAt: application.appliedAt,
        jobCategory: job.jobCat,
        jobName: job.jobName,
        jobPay: job.jobPay,
      };
    });
}, [jobArray, jobApplications]);

const applicantMap = useMemo(() => {
  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
  const storageKey = `applicants-${today}`;

  const saved = JSON.parse(localStorage.getItem(storageKey) || "{}");

  const map = {};

  appliedJobs.forEach(job => {
    const jobId = job.id;

    if (saved[jobId] !== undefined) {
      map[jobId] = saved[jobId];
    } else {
      const newValue = Math.floor(Math.random() * 200);
      map[jobId] = newValue;
      saved[jobId] = newValue;
    }
  });

  localStorage.setItem(storageKey, JSON.stringify(saved));

  return map;
}, [appliedJobs]);

  useEffect(() => {
    if (!effectiveInCooldown || !effectiveCooldownUntil) return;
    
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const cooldownTime = new Date(effectiveCooldownUntil).getTime();
      const remaining = Math.max(0, Math.floor((cooldownTime - now) / 1000));
      
      setRemainingCooldownSecs(remaining);
      
      if (remaining === 0 && effectiveInCooldown) {
        useSocketStore.getState().resetCooldown();
        usefbStore.getState().resetCooldown();
        Swal.fire({
          title: "New Tasks Available!",
          text: "Your cooldown period is over. You can now request new tasks.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }, 1000);
    
    return () => clearInterval(interval);
  }, [effectiveInCooldown, effectiveCooldownUntil]);

  useEffect(() => {
    if (!userID) return;
    const socket = useSocketStore.getState();
    socket.setUid(userID);
    socket.connect();
  }, [userID]);
  
  function getUserLevel(accountPoints) {
    if (accountPoints >= 4000) return "Pro";
    if (accountPoints >= 2000) return "Master";
    if (accountPoints >= 1000) return "Journeyman";
    return "Rookie";
  }

  useEffect(() => {
    if (taskRespStatus === "Cooldown" && taskRespMsg) {
      Swal.fire({
        title: "Tasks on Cooldown",
        text: taskRespMsg,
        icon: "info",
        timer: 5000,
        showConfirmButton: false,
      });
            setGettingTask(false)

    } else if (taskRespMsg && taskRespStatus && taskRespStatus !== "Cooldown") {
      Swal.fire(`${taskRespStatus}`, `${taskRespMsg}`, "warning");
      setGettingTask(false)
    }
  }, [taskRespCont, taskRespMsg, taskRespStatus]);
  const handleAccept = (taskId, type) => {
    navigate(`/workpopup/${taskId}/${type}`);
  };
  const handleResumeTask = (taskId, taskType) => {
    navigate(`/workspace/${taskId}/${taskType}`);
  };
  
  const getTask = () => {
    // Check account verification first
    if (!accountVerified) {
      Swal.fire({
        title: "Verification Needed",
        text: "Please verify your account to start working on tasks.",
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      });
      return;
    }else if(accountVerified){
 if (effectiveInCooldown) {
      Swal.fire({
        title: "Tasks on Cooldown",
        text: cooldownMessage || `New tasks available in ${formatCooldownTime(remainingCooldownSecs)}`,
        icon: "info",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    } 
    
    if (screenCount == null) {
      return;
    }
    
    if (screeningTest == "undone") {
      Swal.fire({
        title: "Screening Required",
        text: "Please complete a short screening test before accessing live tasks.",
        icon: "info",
        showConfirmButton: true,
        confirmButtonText: "Take Test",
        showCancelButton: true,
        cancelButtonText: "Maybe Later",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/prescreening");
        }
      });
    } else if (screeningTest == "pass") {
      if(!secApproval){
        Swal.fire("Awaiting Tasks","Please stand by as we allocate tasks to you.", "info")

      }else if(secApproval){
        const socket = useSocketStore.getState();
        socket.send({
          type: "requestTask",
          uid: userID,
        });
        setGettingTask(true);
      } 
    } else if (screeningTest == "fail") {
      if (screenCount < 2) {
        Swal.fire({
          title: "Try Again",
          text: "It looks like you didn't pass the screening test. Would you like to retake it?",
          icon: "info",
          showConfirmButton: true,
          confirmButtonText: "Retake Test",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/prescreening");
          }
        });
      } else if (screenCount >= 2) {
        Swal.fire(
          "Screening Limit Reached",
          "You've reached the maximum number of attempts. Please contact our support team to request a review or reset.",
          "info"
        );                
      }
    }
    }
    
   
  };
  useEffect(() => {
    if (authStatus !== "authenticated" || !userID) return;

    const tasksCol = collection(db, "Users", userID, "assignedTasks");

    const unsub = onSnapshot(tasksCol, (snapshot) => {
      if (snapshot.empty) {
        setHasTasks(false);
        setTaskArray([]);
      } else {
        const tasks = snapshot.docs.map((docSnap) => ({
          taskId: docSnap.id,
          ...docSnap.data(),
        }));
        setHasTasks(true);
        setTaskArray(tasks);
      }
    });

    return () => unsub();
  }, [userID, authStatus]);

  const redeemTokens = () => {
    navigate("/redeemtokens")
  }

  const openAccounts = () => {
    setAllAccountLevels(true)
  }

  return (
    <div className="mdlminiContWrapper">
      <div
        className={`mainDashLeft ${
          isDesktopLeftDashActive && isDesktopRightDashActive ? "allDashActive" : ""
        } ${isDesktopLeftDashActive ? "mainDashLeftFonActive-Desk" : "mainDashLeftFonInActive-Desk"}`}
      >
        <div className={`mdlTop ${isDesktopLeftBottomActive ? "mdlTopHide" : "mdlTopNuetral"}`}>
          <div className="mdlCard1">
            <img className="mdlCard1Img" src={wavecard} alt="" />
            <div className="mdlCard1Cont">
              <img src={lineGraphImg} alt="" />
              <span className="mdlCard1Income">${accountBalance.toLocaleString()}</span>
                  <span className="mdlcardTitle">Earnings</span>
            </div>
          </div>
          <div className="mdlCard2">
            <div className="mdlcard2Wrap">
              <div className="mdlminicard" onClick={() => openAccounts()}>
                <div className="mdlminicardCont">
                  <div className="mdlminiCardBox">
                    <Icon className="faIcon" icon="solar:medal-star-bold-duotone" />
                  </div>
                  <div className="mdlminicardContData">
                    <div className="mdlContToken">
                      <p>{getUserLevel(accountPoints)}</p>
                      <span>Rank</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mdlminicard">
                <div className="mdlminicardCont">
                  <div className="mdlminiCardBox">
                    <Icon className="faIcon" icon="solar:clipboard-check-bold-duotone" />
                  </div>
                  <div className="mdlminicardContData">
                    <div className="mdlContToken">
                      <p className="mdlContTokenNumber">{totalTaskTaken.toLocaleString()}</p>
                      <span>Tasks Completed</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mdlminicard">
                <div className="mdlminicardCont">
                  <div className="mdlminiCardBox">
                    <Icon className="faIcon" icon="solar:stop-circle-bold" />
                  </div>
                  <div className="mdlminicardContData" onClick={() => redeemTokens()}>
                    <div className="mdlContToken">
                      <p className="mdlContTokenNumber">{solaraTokens.toLocaleString()}</p>
                      <span>Solara Tokens</span>
                    </div>
                    <div className="mdlContTokenBuy" >
                      <Icon className="faIcon" icon="solar:arrow-right-up-line-duotone" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`mdlBtm ${isDesktopLeftBottomActive ? "mdlBtmActive" : ""}`}>
          <div className="mdlBtmIntro">
            <span>Available AI Tasks</span>
          </div>
          <div className="mdlBtmAITasksAssigned">
            { hasTasks ? (
              <div className="accTaskAssignedWrapper">
                {taskArray.map((task) => (
                  <div key={task.taskId} className="aitaskassignedCard">
                    <div className="aacTaskType">
                      <p>{task.type}</p>
                    </div>
                    <div className="aacTaskPay">
                      <p>
                        Pay <span>${task.pay}</span>
                      </p>
                    </div>
                    <div className={`aacTaskStatus ${task.status === "Pending" ? "aacTaskStatusPending" : "aacTaskStatusComplete"}`}>
                      <p>{task.status || "Pending"}</p>
                    </div>
                    <div className="aacTaskAction">
                      {task.status === "Pending" ? (
                        <p className="acceptTaskBtn" onClick={() => handleAccept(task.taskId, task.type)}>
                          Accept
                        </p>
                      ) : task.status === "active" ? (
                        <p className="resumeTaskBtn" onClick={() => handleResumeTask(task.taskId, task.type)}>
                          Resume
                        </p>
                      ) : (
                        <p className="nullBtn">-</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                <img src={aitaskImg} alt="" />
                <span ref={taskResp}>
                  {effectiveInCooldown 
                    ? `New tasks available in ${formatCooldownTime(remainingCooldownSecs)}` 
                    : "You have not yet been assigned a task."}
                </span>

                {gettingTask ? (
                  <div className="loadingSpinner">
 <Jelly
                                  size="45"
                                  speed="1"
                                  color="#6a5acd" 
                                ></Jelly>
                                                  </div>
                ):( <button 
                  onClick={() => getTask()}
                  disabled={effectiveInCooldown}
                  style={{
                    opacity: effectiveInCooldown ? 0.6 : 1,
                    cursor: effectiveInCooldown ? "not-allowed" : "pointer"
                  }}
                >
                  {effectiveInCooldown ? `(${formatCooldownTime(remainingCooldownSecs)})` : "Get Task"}
                </button>)}
               
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`mainDashRight ${
          isDesktopLeftDashActive && isDesktopRightDashActive ? "allDashActive" : ""
        } ${isDesktopRightDashActive ? "mainDashRightFonActive-Desk" : "mainDashLeftFonInActive-Desk"}`}
      >
        <div className="mdrIntro">
          <p>Applied Jobs</p>
        </div>
        <div className="mdrCont" >
          {appliedJobs.length === 0 ? (
            <div className="noApplications">
              <img src={noApplication} alt="" />
              <span>No job applications found.</span>
              <button onClick={() => navigate("/jobs")}>Apply</button>
            </div>
          ):(<div className="appliedJobsListing">
  {appliedJobs.map((job) => (
    <div className="apjlCard" key={job.id}>
      <div className="apjlCardTop">
        <div className="apjlIcon">
          <Icon
            className="faIcon"
            icon="solar:case-outline"
          />
        </div>

        <div className="apjlCardTopCont">
          <span className="apjlJobTitle">
            {job.jobName} 
          </span>

          <p className="apjlJobCategory">
            Contract

          </p>

          <p className="aplJobPay">
            Pay: <span>${job.jobPay} /hr</span>
          </p>
        </div>
      </div>

      <div className="apjlCardBottom">
        <p className="apjlViewDetails">
  <Icon
    className="faIcon"
    icon="solar:users-group-rounded-linear"
  />
  {applicantMap[job.id] || 0} applicants
</p>
     <p className="apjlStatus">
          {job.applicationStatus}
        </p>
      </div>
    </div>
  ))}
</div>)}
     
         
        </div>
      </div>
    </div>
  );
}

export default Maindash;